import { CONTROL_NAME, controlsForDisplay } from './types'

export const EXCLUDED_TYPES_WITHOUT_PRODUCT_SELECTION_CONTROL = [
  CONTROL_NAME.ENTITY_LOOKUP_CONTROL,
  ...controlsForDisplay
]

/**
 * @todo Understand whether it still makes sense to exclude product selection in any scenario
 */
export const EXCLUDED_TYPES = [
  CONTROL_NAME.PRODUCT_SELECTION_CONTROL,
  ...EXCLUDED_TYPES_WITHOUT_PRODUCT_SELECTION_CONTROL
]
